module.exports = __webpack_public_path__ + "img/me.420389a1.svg";